import { porterStemmer } from './porterStemmer';

// The locale whose rules apply to search text. The server sets this global; it is not the
// active UI locale.
function getSearchLocale(): string {
    return (window as { serverDeterminedLocale?: string }).serverDeterminedLocale || 'en';
}

export function stemmedWords(text: string, locale: string = getSearchLocale()): string[] {
    // Only lowercase text made entirely of extended ASCII characters (the first 256 code points)
    let latin = true;
    for (let i = 0; i < text.length; i++) {
        if (text.charCodeAt(i) > 255) latin = false;
    }
    let normalized = latin ? text.toLowerCase() : text;

    // The regex word class only covers the base-Latin block, so non-word characters are scrubbed and
    // words are stemmed for English only. See https://github.com/quanticedu/back_royal/issues/2203
    if (locale === 'en') normalized = normalized.replace(/[^\w]/g, ' ');

    const wordlist = normalized.replace(/\s+/g, ' ').split(' ');

    return locale === 'en' ? wordlist.map(word => porterStemmer(word)) : wordlist;
}

export function stemmedWordsSet(texts: (string | null | undefined)[], locale: string = getSearchLocale()) {
    const terms = new Set<string>();
    texts.forEach(text => {
        if (!text) return;
        stemmedWords(text, locale).forEach(term => terms.add(term));
    });
    return terms;
}
